import { useCallback, useRef, useState } from 'react';
import { isAudioSilent } from '@/shared/audio/isAudioSilent';

export function useSilentAudioConfirm() {
  const [open, setOpen] = useState(false);
  const resolverRef = useRef(null);

  const settle = useCallback((value) => {
    const resolve = resolverRef.current;
    if (!resolve) return;
    resolverRef.current = null;
    setOpen(false);
    resolve(value);
  }, []);

  const requestConfirm = useCallback(() => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setOpen(true);
    });
  }, []);

  const confirmIfSilent = useCallback(async (blob) => {
    const silent = await isAudioSilent(blob);
    if (!silent) return true;
    return requestConfirm();
  }, [requestConfirm]);

  const onOpenChange = useCallback((nextOpen) => {
    if (!nextOpen) settle(false);
  }, [settle]);

  return {
    confirmIfSilent,
    dialogProps: {
      open,
      onOpenChange,
      onConfirm: () => settle(true),
    },
  };
}
